namespace TabAurous.Purchase {
    export namespace ApprovalInReturnItemsService {
        export const baseUrl = 'PurchaseReturn/ApprovalnReturnItems';

        export declare function Create(request: Serenity.SaveRequest<ApprovalInReturnItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ApprovalInReturnItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ApprovalInReturnItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalInReturnItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "PurchaseReturn/ApprovalnReturnItems/Create",
            Update = "PurchaseReturn/ApprovalnReturnItems/Update",
            Delete = "PurchaseReturn/ApprovalnReturnItems/Delete",
            Retrieve = "PurchaseReturn/ApprovalnReturnItems/Retrieve",
            List = "PurchaseReturn/ApprovalnReturnItems/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ApprovalInReturnItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
